(function () {
  const dyEventsConfig = typeof window !== "undefined" ? window.DY_EVENTS_CONFIG || {} : {};
  /** Theme setting: Cart → Dynamic Yield Recommendations → Enable DY Events debug logging */
  const DY_EVENTS_DEBUG = dyEventsConfig.debug !== false;
  /** Theme setting: Cart → Dynamic Yield Recommendations → Enable DY SPA page context */
  const DY_SPA_ENABLED = dyEventsConfig.spaEnabled !== false;

  function log() {}

  function warn() {
      if (DY_EVENTS_DEBUG && typeof console !== "undefined" && console.warn) {
          console.warn.apply(console, arguments);
      }
  }

  function error() {
      if (DY_EVENTS_DEBUG && typeof console !== "undefined" && console.error) {
          console.error.apply(console, arguments);
      }
  }

  log("[DY Events] Script loaded - Initializing DynamicYield events...");

  /** @typedef {Window & { BVDY?: any; Shopify?: any; DY?: any; DYO?: any; dyTrackNewsletterSubscription?: Function }} WindowWithBVDY */
  /** @type {WindowWithBVDY} */
  const win = window;
  
  // Wait for BVDY to be available
  /**
   * @param {() => void} callback
   * @param {number} maxAttempts
   */
  function waitForBVDY(callback, maxAttempts = 50) {
      let attempts = 0;
      const checkInterval = setInterval(() => {
          attempts++;
          if (win.BVDY) {
              clearInterval(checkInterval);
              log("[DY Events] BVDY found after", attempts * 100, "ms");
              callback();
          } else if (attempts >= maxAttempts) {
              clearInterval(checkInterval);
              error("[DY Events] ❌ BVDY not found after", maxAttempts * 100, "ms - Events will not be tracked");
          }
      }, 100);
  }

  /**
   * Helper: build DY product payload
   */
  /**
   * @param {{dyType?: string, variantId?: string | number | null, productId?: string | number | null, quantity?: number, value?: number, currency?: string, source?: string}} params
   */
  function dyProductPayload({ dyType, variantId, productId, quantity, value, currency, source }) {
    return {
      variant_id: variantId ? String(variantId) : undefined,
      productId: productId ? String(productId) : undefined,
      dyType: dyType?? "",
      quantity: quantity || 1,
      value: value,
      currency: currency || win.Shopify?.currency?.active || "USD",
      source: source || "web",
      page_url: location.href,
    };
  }

  /**
   * ADD_TO_CART
   * - Track Shopify Ajax add to cart
   * - Track DY slider add to cart button clicks
   */
  function bindAddToCart() {
    document.addEventListener("cart:added", async function (e) {
      // @ts-ignore
      const data = e.detail?.data;
      if (!data || data.didError) return;

      const addedItem = Array.isArray(data.addedItems) && data.addedItems.length > 0 ? data.addedItems[0] : null;
      if (!addedItem) return;

      const variantId = data.variantId || String(addedItem.variant_id ?? addedItem.id ?? "");
      const variantSku = addedItem.sku || "";
      const variantPrice = addedItem.price != null ? addedItem.price / 100 : undefined;
      const qty = addedItem.quantity || data.itemCount || 1;

      const payload = dyProductPayload({
        dyType: "add-to-cart-v1",
        value: variantPrice ? variantPrice * qty : undefined,
        currency: "USD",
        productId: variantSku,
        variantId,
        quantity: qty,
        source: "product_form",
      });
      log("[DY Events] 🛒 ADD_TO_CART triggered (cart:added):", payload);
      if (win.BVDY) {
        win.BVDY.sendEvent("Add to Cart", payload);
        setTimeout(async () => {
          await sendSyncCart("web");
          // Update the cart page context if drawer is open / cart page
          sendCartRecommendationContext();
        }, 1500);
      } else {
        warn("[DY Events] ⚠️ BVDY not available, event not sent");
      }
    });
    // document.addEventListener("submit", async function (e) {
    //   const form = e.target;
    //   log('DY Form: Add to Cart', form);
    //   if (!(form instanceof HTMLFormElement)) return;
    //   if (!form.matches('form[action^="/cart/add"]')) return;

    //   // Add-to-cart submit happens before actual request → fire intent event
    //   const formData = new FormData(form);
    //   const rawId = formData.get("id");
    //   // @ts-ignore
    //   const variantSku = form.querySelector('input[name="id"]')?.dataset.variantSku;
    //   // @ts-ignore
    //   const variantPrice = form.querySelector('input[name="id"]')?.dataset.variantPrice;
    //   const variantId = typeof rawId === "string" ? rawId : rawId ? String(rawId) : null;
    //   const qtyRaw = formData.get("quantity");
    //   const qtyStr = typeof qtyRaw === "string" ? qtyRaw : qtyRaw ? String(qtyRaw) : "1";
    //   const qty = parseInt(qtyStr, 10) || 1;

    //   const payload = dyProductPayload({
    //     dyType: "add-to-cart-v1",
    //     value: variantPrice,
    //     currency: "USD",
    //     productId: variantSku,
    //     variantId,
    //     quantity: qty,
    //     source: "product_form_submit",
    //   });
    //   log("[DY Events] 🛒 ADD_TO_CART triggered (form submit):", payload);
    //   if (win.BVDY) {
    //       win.BVDY.sendEvent("Add to Cart", payload);
    //       sendSyncCart("web");
    //   } else {
    //       warn("[DY Events] ⚠️ BVDY not available, event not sent");
    //   }
    // });

    // DY slider buttons: .dy-recommendation-item__add-to-cart
    document.addEventListener("click", function (e) {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const btn = target.closest(".dy-recommendation-item__add-to-cart");
      if (!btn) return;

      const variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;

      const payload = dyProductPayload({
        variantId,
        productId: null,
        // @ts-ignore
        price: undefined,
        currency: undefined,
        quantity: 1,
        source: "dy_reco_slider",
      });
      log("[DY Events] 🛒 ADD_TO_CART triggered (DY slider):", payload);
      if (win.BVDY) {
          win.BVDY.sendEvent("Add to Cart", payload);
      } else {
          warn("[DY Events] ⚠️ BVDY not available, event not sent");
      }
    });
  }


  function bindAddToWishlist() {
    document.addEventListener("wishlist:updated", (e) => {
      // @ts-ignore
      const data = e.detail;
      if(data.action == 'added') {
        let currenWishlistDom = document.querySelector('wishlist-button[data-variant-id="'+data.variantId+'"]')
          || document.querySelector('wishlist-product-icon[data-variant-id="'+data.variantId+'"]');
        let productId = data.sku || data.productId || "";
        if(currenWishlistDom && !productId) {
          // @ts-ignore
          productId = currenWishlistDom.getAttribute('data-sku') || currenWishlistDom.getAttribute('data-product-id') || "";
        }
        // @ts-ignore
        const payload = {
          dyType: "add-to-wishlist-v1",
          productId: productId,
        };
        log("[DY Events] 💖 ADD_TO_WISHLIST triggered:", payload);
        if (win.BVDY) {
          win.BVDY.sendEvent("Add to Wishlist", payload);
        } else {
          warn("[DY Events] ⚠️ BVDY not available, event not sent");
        }
      }
    });
  }
  /**
   * REMOVE_FROM_CART
   * - Detect cart change links/buttons
   */
  function bindRemoveFromCart() {
    document.addEventListener("click", function (e) {
      const target = e.target;
      if (!(target instanceof Element)) return;
      const el = target.closest(
        'a[href*="/cart/change"], button[name="remove"], .cart__remove, .remove, [data-cart-remove], .bv-cart-remove'
      );
      if (!el) return;

      // If possible, capture line id from href
      let line = null;
      const href = el.getAttribute("href") || "";
      const psku = el.getAttribute('data-psku') || "";
      const pprice = el.getAttribute('data-pprice') || "";
      const pqty = el.getAttribute('data-pqty') || "";
      const m = href.match(/line=(\d+)/);
      if (m) line = m[1];

      log("[DY Events] 🗑️ REMOVE_FROM_CART triggered:", {
        el,
        href,
        psku,
        pprice,
        pqty,
        line,
      });

      const payload = {
        dyType: "remove-from-cart-v1",
        value: parseFloat(pprice),
        productId: psku,
        quantity: parseInt(pqty)
      };
      log("[DY Events] 🗑️ REMOVE_FROM_CART triggered:", payload);
      if (win.BVDY) {
          win.BVDY.sendEvent("Remove from Cart", payload);
          setTimeout(async () => {
            await sendSyncCart("web");
            // Update the cart page context if drawer is open / cart page
            sendCartRecommendationContext();
          }, 1500);
      } else {
          warn("[DY Events] ⚠️ BVDY not available, event not sent");
      }
    });
  }

  function bindRemoveFromCartAjax() {
    const originalFetch = window.fetch;
  
    window.fetch = async function (...args) {
     
      const req = args[0];
      let url = "";

      if (typeof req === "string") {
        url = req;
      } else if (req instanceof Request) {
        url = req.url;
      } else if (req instanceof URL) {
        url = req.toString();
      } else {
        url = String(req || "");
      }
  
      const res = await originalFetch.apply(this, args);
  
      try {
        if (!url) return res;
  
        // Horizon uses these endpoints
        const isCartChange =
          url.includes("/cart/change.js") ||
          url.includes("/cart/update.js") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update");
  
        if (!isCartChange) return res;
  
        const init = args[1] || {};
        const body = init.body;
  
        /** @type {Record<string, any>} */
        let payloadBody = {};
        if (typeof body === "string") {
          try {
            payloadBody = JSON.parse(body);
          } catch (e) {
            // urlencoded form fallback
            payloadBody = Object.fromEntries(new URLSearchParams(body));
          }
        }
  
        // Horizon patterns
        const qty = payloadBody.quantity ?? payloadBody.qty ?? null;
        const id = payloadBody.id ?? payloadBody.variant_id ?? null;
        const line = payloadBody.line ?? null;
  
        // Remove = quantity 0
        if (String(qty) === "0") {
          const payload = {
            variant_id: id ? String(id) : undefined,
            line: line ? String(line) : undefined,
            page_url: location.href,
            source: "cart_ajax",
          };
  
          log("[DY Events] 🗑️ REMOVE_FROM_CART triggered (AJAX):", payload);
          win.BVDY?.sendEvent("Remove from Cart", payload);
        }
      } catch (err) {
        // ignore
      }
  
      return res;
    };
  }
  

  /**
   * SYNC_CART
   * - Triggered when cart is opened / updated
   * - We'll send when cart drawer opens OR cart page loaded
   */
  async function sendSyncCart(source = "web") {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      const cart = await res.json();

      // Keep window._CURRENT_CART in sync whenever we already have fresh cart data
      // @ts-ignore
      if (cart && Array.isArray(cart.items)) {
        // @ts-ignore
        window._CURRENT_CART = {
          cartToken: cart.token,
          cartCount: cart.item_count,
          cart: cart,
        };
      }

      // @ts-ignore
      const cartItems = cart.items.map(item => ({
        productId: item.sku,
        quantity: item.quantity,
        itemPrice: item.final_line_price / 100
      }));

      const payload = {
        dyType: "sync-cart-v1",
        value: cart.total_price/100,
        currency: win.Shopify?.currency?.active || "USD",
        cart: cartItems,
        source,
        item_count: cart.item_count,
        page_url: location.href,
      };
      log("[DY Events] 🛍️ SYNC_CART triggered:", payload);
      if (win.BVDY) {
          win.BVDY.sendEvent("Sync cart", payload);
      } else {
          warn("[DY Events] ⚠️ BVDY not available, event not sent");
      }
    } catch (e) {
      // ignore
    }
  }

  /** Tracks cart-drawer visibility across the async open (rAF → showModal) gap. */
  let cartDrawerDyContextActive = false;

  function isCartDrawerOpen() {
    const dialog = document.querySelector("cart-drawer-component dialog");
    return dialog instanceof HTMLDialogElement && dialog.open;
  }

  function flushCartRecommendationContext() {
    // @ts-ignore
    const cartItems = (window._CURRENT_CART?.cart?.items || []).map(item => item.sku);
    const payload = {
      context: {
        type: "CART",
        // @ts-ignore
        data: cartItems
      },
      countAsPageview: false,
      page_url: location.href,
      source: "web",
    };
    log("[DY Events] 🛒 CART recommendation context:", payload);
    if (win.BVDY) {
      if (DY_SPA_ENABLED) {
        log("[DY Events - DY_SPA_ENABLED] 🛒 CART recommendation context:", payload);
        win.BVDY.sendPageContext("spa", payload);
      }
      // @ts-ignore
      window.DY.recommendationContext = {
        type: "CART",
        data: cartItems
      };
    } else {
      warn("[DY Events] ⚠️ BVDY not available, event not sent");
    }
  }

  /**
   * Send CART context only when cart page is active or the cart drawer is open.
   * Opening-in-progress is handled by cart:drawer:opened (fired after dialog:open).
   */
  function sendCartRecommendationContext() {
    if (location.pathname === "/cart" || cartDrawerDyContextActive || isCartDrawerOpen()) {
      flushCartRecommendationContext();
    }
  }

  function bindSyncCart() {
    // cart page
    if (location.pathname === "/cart") {
      sendSyncCart("web");
      return;
    }
  
    // after add-to-cart ajax: many themes fire events, but fallback by observing cart drawer updates
    const cartRoot = document.querySelector("cart-drawer") || document.querySelector("[data-cart-drawer]");
    if (cartRoot) {
      const obs = new MutationObserver(() => sendSyncCart("cart_mutation"));
      obs.observe(cartRoot, { childList: true, subtree: true });
    }
  }

  /**
   * KEYWORD_SEARCH
   * - Detect /search?q= OR search form submit
   */
  function bindKeywordSearch() {
    // on search page load
    if (location.pathname.includes("/search")) {
      const q = new URLSearchParams(location.search).get("q");
      if (q) {
        const payload = {
          dyType: "keyword-search-v1",
          keyword: q,
          page_url: location.href,
        };
        log("[DY Events] 🔍 KEYWORD_SEARCH triggered (page load):", payload);
        if (win.BVDY) {
            win.BVDY.sendEvent("Keyword Search", payload);
        } else {
            warn("[DY Events] ⚠️ BVDY not available, event not sent");
        }
      }
    }

    // search form submit
    document.addEventListener("submit", function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const input = form.querySelector('input[name="q"], input[type="search"]');
      if (!(input instanceof HTMLInputElement)) return;

      const keyword = (input.value || "").trim();
      if (!keyword) return;

      const payload = {
        dyType: "keyword-search-v1",
        keyword,
        page_url: location.href,
      };
      log("[DY Events] 🔍 KEYWORD_SEARCH triggered (form submit):", payload);
      if (win.BVDY) {
          win.BVDY.sendEvent("Keyword Search", payload);
      } else {
          warn("[DY Events] ⚠️ BVDY not available, event not sent");
      }
    });
  }

  /**
   * SORT_ITEMS, FILTER_ITEMS
   */
  function bindSortAndFilter() {
    // Sort dropdown commonly name="sort_by"
    document.addEventListener("change", function (e) {
      const el = e.target;
      if (!(el instanceof HTMLInputElement || el instanceof HTMLSelectElement || el instanceof HTMLTextAreaElement)) return;
      const control = el;

      if (control.name === "sort_by") {
        const payload = {
          dyType: "sort-items-v1",
          sortBy: control.value,
          page_url: location.href,
        };
        log("[DY Events] 📊 SORT_ITEMS triggered:", payload);
        if (win.BVDY) {
            win.BVDY.sendEvent("Sort Items", payload);
        } else {
            warn("[DY Events] ⚠️ BVDY not available, event not sent");
        }
      }

      // Filters: commonly have data-filter / name contains filter
      if (control.matches('[name*="filter"], [data-filter], [data-facet]')) {
        const payload = {
          dyType: "filter-items-v1",
          filterType: control.name || control.getAttribute("data-filter") || control.getAttribute("data-facet") || "unknown",
          filterStringValue: control.value || control.getAttribute("value") || "unknown",
          page_url: location.href,
        };
        log("[DY Events] 🔽 FILTER_ITEMS triggered:", payload);
        if (win.BVDY) {
            win.BVDY.sendEvent("Filter Items", payload);
        } else {
            warn("[DY Events] ⚠️ BVDY not available, event not sent");
        }
      }
    });
  }

  /**
   * CHANGE_ATTRIBUTE
   * - PDP variant selection etc
   */
  function bindChangeAttribute() {
    let lastTrackedVariantId = null;

    // Event contains: resource (variant object), sourceId, data (html, productId)
    // document.addEventListener('variant:update', function (event) {
    //   // @ts-ignore - event detail from theme
    //   const detail = event.detail;
    //   const variant = detail?.resource;

    //   // Only track if variant exists and is different from last tracked
    //   if (variant && variant.id !== lastTrackedVariantId) {
    //     lastTrackedVariantId = variant.id;
    //     const payload = {
    //       dyType: "change-attr-v1",
    //       attributeType: control.name,
    //       attributeValue: control.value,
    //       page_url: location.href,
    //     };
    //     log("[DY Events] 🔄 CHANGE_ATTRIBUTE triggered (Horizon radio):", variant);
    //   }
    // });
    document.addEventListener("change", function (e) {
      const el = e.target;
      if (!(el instanceof HTMLInputElement || el instanceof HTMLSelectElement)) return;
  
      const control = el;
  
      // ✅ Horizon Variant Picker (radio pills)
      if (
        control instanceof HTMLInputElement &&
        control.type === "radio" &&
        control.closest(".variant-picker__form") &&
        control.hasAttribute("data-variant-id")
      ) {
        const payload = {
          dyType: "change-attr-v1",
          attributeType: control.name.split('-')[0],
          attributeValue: control.value,
          page_url: location.href,
        };
  
        log("[DY Events] 🔄 CHANGE_ATTRIBUTE triggered (Horizon radio):", payload);
        win.BVDY?.sendEvent("Change Attribute", payload);
        return;
      }
  
      // ✅ existing selectors (keep for other themes)
      if (control.matches('select[name*="options"], input[name*="options"], select[name="id"]')) {
        const payload = {
          dyType: "change-attr-v1",
          attributeType: control.name.split('-')[0],
          attributeValue: control.value,
          page_url: location.href,
        };
        log("[DY Events] 🔄 CHANGE_ATTRIBUTE triggered:", payload);
        win.BVDY?.sendEvent("Change Attribute", payload);
      }
    });
  }

  /**
   * NEWSLETTER_SUBSCRIPTION
   * Track newsletter subscription events
   * @param {string} email - User's email address
   * @param {object} options - Additional options
   * @param {string} [options.phoneNumber] - User's phone number
   * @param {string} [options.ecommerceId] - User's ecommerce ID (customer ID)
   * @param {boolean} [options.canadaConsent] - Canada consent flag
   */
  function trackNewsletterSubscription(email, options = {}) {
    if (!email) {
      warn("[DY Events] ⚠️ Newsletter subscription: email is required");
      return;
    }

    // Check if DY and DYO are available
    if (!win.DY || !win.DYO) {
      warn("[DY Events] ⚠️ DY or DYO not available, newsletter event not sent");
      return;
    }

    try {
      // Hash the email using DYO.dyhash.sha256
      const hashedEmail = win.DYO.dyhash.sha256(email.toLowerCase());
      
      // Build secondary identifiers array
      /** @type {Array<{type: string, value: string}>} */
      const secondaryIdentifiers = [];
      
      if (options.phoneNumber) {
        secondaryIdentifiers.push({
          type: "phoneNumber",
          value: options.phoneNumber
        });
      }
      
      if (options.ecommerceId) {
        secondaryIdentifiers.push({
          type: "ecommerceID",
          value: String(options.ecommerceId)
        });
      }

      // Build the event payload
      /** @type {Record<string, any>} */
      const properties = {
        dyType: "newsletter-subscription-v1",
        cuid: hashedEmail,
        cuidType: "he",
        // email: email,
        page_url: location.href,
        timestamp: new Date().toISOString()
      };

      // Add secondary identifiers if any exist
      if (secondaryIdentifiers.length > 0) {
        properties.secondaryIdentifiers = secondaryIdentifiers;
      }

      // Add custom properties
      if (options.canadaConsent !== undefined) {
        properties.canadaConsent = options.canadaConsent;
      }

      const eventPayload = {
        name: "Newsletter Subscription",
        properties: properties
      };

      log("[DY Events] 📧 NEWSLETTER_SUBSCRIPTION triggered:", eventPayload);
      
      // Send the event to Dynamic Yield
      win.DY.API("event", eventPayload);

    } catch (error) {
      error("[DY Events] ❌ Error sending newsletter subscription event:", error);
    }
  }

  // Expose trackNewsletterSubscription globally for use in other scripts
  win.dyTrackNewsletterSubscription = trackNewsletterSubscription;
  
  /** @type {Record<string, any> | null} */
  let savedDyRecommendationContext = null;

  // @ts-ignore
  function restoreDyRecommendationContext(context) {
    if (!context || !win.BVDY) return;

    const payload = {
      context: {
        type: context.type,
        data: context.data,
        ...(context.lng ? { lng: context.lng } : {}),
      },
      countAsPageview: false,
      page_url: location.href,
      source: "web",
    };

    if (DY_SPA_ENABLED) {
      win.BVDY.sendPageContext("spa", payload);
    }
    // @ts-ignore
    window.DY.recommendationContext = context;
    log("[DY Events] 🔄 DY recommendationContext restored:", context);
  }

  function bindCartDrawerOpened() {
    document.addEventListener("cart:drawer:opened", function (e) {
      // @ts-ignore
      const source = e.detail.data?.source;
      log('DY Cart drawer opened', source);
      if (source === "cart-drawer-component") {
        if (!cartDrawerDyContextActive) {
          // @ts-ignore
          const currentContext = window.DY?.recommendationContext;
          savedDyRecommendationContext = currentContext
            ? JSON.parse(JSON.stringify(currentContext))
            : null;
          cartDrawerDyContextActive = true;
        }

        sendCartRecommendationContext();
      }
    });

    document.addEventListener("cart:drawer:closed", function (e) {
      // @ts-ignore
      const source = e.detail?.data?.source;
      if (source !== "cart-drawer-component" || !cartDrawerDyContextActive) return;

      cartDrawerDyContextActive = false;
      // const context = savedDyRecommendationContext;
      // savedDyRecommendationContext = null;

      // if (context) {
      //   restoreDyRecommendationContext(context);
      // } else {
      //   warn("[DY Events] ⚠️ No saved DY context to restore after cart drawer close");
      // }
    });

  }

  // @ts-ignore
  function isEmptyObject(obj) {
    return !obj || Object.keys(obj).length === 0;
  }

  // Live tv product data keys to watch
  const WATCH_KEYS = ['eventType', 'productID', 'productIDs'];

  // @ts-ignore
  function wrapWithProxy(obj) {
    return new Proxy(obj || {}, {
      set(target, prop, value) {
        const oldValue = target[prop];
        target[prop] = value;

        // @ts-ignore
        if (WATCH_KEYS.includes(prop) && oldValue !== value && !isEmptyObject(target)) {
          // @ts-ignore
          log(`DY Live TV: liveTvProductData.${prop} changed:`, oldValue, '→', value);
          onLiveTvProductDataChange(target);
        }

        return true;
      },
      get(target, prop) {
        return target[prop];
      }
    });
  }

  // @ts-ignore
  function onLiveTvProductDataChange(data, changedProp, newValue) {
    if (!data || isEmptyObject(data)) return;

    // @ts-ignore
    let liveTvItems = data.productIDs || [];

    const payload = {
      context: {
        type: "other",
        // @ts-ignore
        data: liveTvItems
      },
      countAsPageview: false,
      page_url: location.href,
      source: "web",
    };

    if (win.BVDY) {
      if (DY_SPA_ENABLED) {
        win.BVDY.sendPageContext("spa", payload);
      }
      // @ts-ignore
      window.DY.recommendationContext = {
        type: "other",
        // @ts-ignore
        data: liveTvItems,
        source: "web",
      };
    } else {
      warn("[DY Events] ⚠️ BVDY not available, event not sent");
    }
  }

  // @ts-ignore
  function bindLiveTVEvents() {

        // Watch for full reassignment (window.liveTvProductData = {...})
    // @ts-ignore
    let _internal = wrapWithProxy(window.liveTvProductData || {});

    Object.defineProperty(window, 'liveTvProductData', {
      get() {
        return _internal;
      },
      set(newValue) {
        log('DY Live TV: liveTvProductData fully reassigned:', newValue);

        // Re-wrap the new object with Proxy so we keep watching
        _internal = wrapWithProxy(newValue);

        // Fire event if new value is not empty
        if (!isEmptyObject(newValue)) {
          onLiveTvProductDataChange(newValue);
        }
      },
      configurable: true
    });
      
    
      
  }

  // Init - Wait for both BVDY and DOM
  function initialize() {
      const BVDY = win.BVDY;
      if (!BVDY) {
          warn("[DY Events] ⚠️ BVDY not available yet, retrying...");
          return;
      }
      
      log("[DY Events] 🚀 Initializing DynamicYield event listeners...");
      BVDY.waitForDY(() => {
          log("[DY Events] ✅ DynamicYield ready, binding event listeners");
          bindAddToCart();
          bindRemoveFromCart();
          // bindRemoveFromCartAjax(); // TODO: CV: test for the performance improvement
          bindSyncCart();
          bindCartDrawerOpened();
          bindKeywordSearch();
          bindSortAndFilter();
          bindChangeAttribute();
          if (location.pathname === '/pages/live-tv' || location.pathname === '/pages/live-tv/') {
            bindLiveTVEvents();
          }
          bindAddToWishlist();
          log("[DY Events] ✅ All event listeners bound successfully");
      });
  }
  
  if (document.readyState === 'loading') {
      document.addEventListener("DOMContentLoaded", function () {
          waitForBVDY(initialize);
      });
  } else {
      // DOM already loaded
      waitForBVDY(initialize);
  }

})();
